import actions from './actions'
import mutations from './mutations'

const balanceHistory = {
    namespaced: true,
    state: {
        balanceHistories: [],
        filters: {
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0], // current date minus month
            toDate: new Date().toISOString().split('T')[0],
            clientId: null,
            taxiOrderId: null,
            paymentId: null,
            paymentType: null,
            orderType: null,
            phoneNumber: null
        },
        pagination: {
            length: null,
            page: 1,
            total: null
        },
        isLoaded: false
    },
    actions,
    mutations
}

export default balanceHistory
